module.exports = __webpack_public_path__ + "static/media/hats-on-shelves.ddb0e66b.jpg";